import {
  type ControlPlaneWebRuntimeConfig,
} from "../../../../packages/shared-types/src/control-plane-web.js";

let runtimeConfig: ControlPlaneWebRuntimeConfig | null = null;
let runtimeConfigPromise: Promise<ControlPlaneWebRuntimeConfig> | null = null;

export async function loadControlPlaneRuntimeConfig(): Promise<ControlPlaneWebRuntimeConfig> {
  if (runtimeConfig) {
    return runtimeConfig;
  }
  if (runtimeConfigPromise) {
    return await runtimeConfigPromise;
  }
  runtimeConfigPromise = (async () => {
    const response = await fetch("/api/public/control-plane-web-config", {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });
    if (!response.ok) {
      const detail = await response.text().catch(() => "");
      throw new Error(
        `Control Plane runtime config request failed with ${response.status}${detail ? `: ${detail}` : ""}`,
      );
    }
    runtimeConfig = (await response.json()) as ControlPlaneWebRuntimeConfig;
    return runtimeConfig;
  })();
  try {
    return await runtimeConfigPromise;
  } finally {
    runtimeConfigPromise = null;
  }
}

export function getControlPlaneRuntimeConfig(): ControlPlaneWebRuntimeConfig {
  return runtimeConfig ?? {};
}

export function resetControlPlaneRuntimeConfigForTests(): void {
  runtimeConfig = null;
  runtimeConfigPromise = null;
}
